export const locale = {
    lang: 'es',
    data: {
        EMPLEADOS: {
            EDIT: {
                TITLE: 'MODIFICAR EMPLEADO'
            }
        }
    }
};
